import createClient, { type Client } from "openapi-fetch";
import type { components, paths } from "./generated/schema";

/**
 * A typed client for the BreweryLogistics API, generated from its OpenAPI document. The web app uses this
 * and nothing else, so it can only do what the published API offers.
 */
export type ApiClient = Client<paths>;
export type Schemas = components["schemas"];
export type { paths };

export function createApiClient(baseUrl = ""): ApiClient {
  return createClient<paths>({ baseUrl });
}
